var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"modal-header-parts",domProps:{"innerHTML":_vm._s(_vm.title)}})}
var staticRenderFns = []

export { render, staticRenderFns }